import { z } from 'zod';
export const membershipConfigResponseModel = z.object({
    data: z.object({ attributes: z.object({ zendeskPayload: z.object({ token: z.string(), tokenTtl: z.number() }) }) }),
});
